module.exports = __webpack_public_path__ + "static/img/暴雨.39522246.svg";